<template>
  <div ref="container_app_responsive_embed" class="characters_uberfiles_app">
    <BContainer fluid ref="real_estate_wrapper" class="p-0 real_estate_wrapper" v-if="case_item && case_item.index">
      <BRow class="no-gutters justify-content-center"> 

        <BCol cols="12" role="tablist">
          <div :class="kebabCase(case_item.short_title)" class="accordion item-gallery-effect" :id="`case_index_full_${case_item.index}`" :data-index="case_item.index" :data-thumbnail="kebabCase(case_item.short_title)" >
            <b-card>
              <BRow class="mb-1 justify-content-center">
                <BCol cols="8" sm="4" md="3" lg="3" class="text-center mb-3">
                  <img class="character_img" width="100%" :src="getPicture(case_item.image_path)" />
                </BCol>
                <BCol class="align-self-center offset-lg-1  offset-md-1  offset-lg-0" sm="8" cols="12" md="8" >
                  <div class="embed-text">
                    <h4 class="type"><span><FileIcons :filetype="case_item.type" /> {{ case_item.type }} from:</span><span class="float-right">{{ case_item.date }}</span></h4>
                    <h3 class="author">{{ case_item.short_title }}, {{ case_item.character }}</h3>
                    <div class="text-wrapper">
                      <div class="text-notification"><h2 class="quote text-center">{{ case_item.preview }}</h2></div>
                    </div>
                  </div>
                  
                  <CustomSharingOptions class="justify-content-center" :title="`${case_item.short_title}, ${case_item.character} ${case_item.preview}`" 
                  :url-embed="`https://projects.icij.org/investigations/uber-files/key-figures-in-uber-files/#/${case_item.image_path}/embed`" 
                  :url="`https://www.icij.org/investigations/uber-files/key-people-in-uber-files/?${case_item.image_path}`" :description="case_item.quote"></CustomSharingOptions>

                  <div class="show-more-btn text-center ">
                    <b-button target="_blank" :href="`https://www.icij.org/investigations/uber-files/key-people-in-uber-files/?${case_item.image_path}`" variant="link">
                      READ MORE 
                    </b-button>
                  </div>      
                </BCol>
              </BRow>
            </b-card>
        </div>
        </BCol>
      </BRow>
    </BContainer>
    <AppFooterEmbed>
    </AppFooterEmbed>
  </div>
  
</template>

<style lang="scss">

  body {
    background: #f7f7f7;
    padding-bottom: 35px;
  }

  .embed-text {
    .text-wrapper {
      background-image: url('../assets/corner.png');
      background-repeat: no-repeat;
      background-position: left top;
      padding-left: 30px;
    }

    h4 {
      font-size: 16px;
      color: var(--app-color-black);
    }
  }

  .text-notification {
    background: #e3e3e3;
    border-radius: 15px;
    padding: 20px 15px;
    margin-bottom: 25px;
  }

  .characters_uberfiles_app {
    max-width: 820px;
    margin: 0 auto;
  }

  .cast_wrapper {
    background-size: contain;
    background-position: top;
  }

  .credits-container {
    background: #ebebeb;
  }

  .credits-story {
    width: 100%;
    max-width: 360px;
    margin: 0 auto;

    h3 {
      font-size: 16px;
    }

    padding: 5vh 0;
  }

  .link-story {
    a {
      background: var(--app-yellow);
      color: #fff;
      font-size: 21px;
      font-weight: 600;
      padding: 5px 10px;

      &:hover {
        background: #000;
      }
    }
  }

  .app-cover {
    padding-top: 0vh;
  }

  .share-case {
    width: 200px;
    margin: 0 auto;
  }

  .cover-top {
    padding-top: 15vh;
    position: relative;
    width: 100%;
    min-height: 720px;
    background: #0D0D0D;

    .app_description span {
      background: #0d0d0dcf;
      line-height: 1.7em;
      padding: 3px 5px;
    }

    .title-cover {
      position: absolute;
      width: 100%;
      z-index: 9;
      top: 90px;

      .logo {
        display: block;
        max-width: 120px;
        text-align: center;
        margin: 0 auto;
      }

      .app_title {
        width: 100%;
        max-width: 720px;
        margin: 0 auto;
        padding: 15px 0;
        text-align: center;
        text-shadow: 1px 1px 3px #000;
        font-family: var(--font-family-base);
        font-size: 65px;
        line-height: 65px;
        text-transform: uppercase;
        color: #fff !important;
        text-shadow: 1px 1px 1px var(--app-color-dark);

        @media (max-width: 767.98px) {
          margin-top: 5vh;
          font-size: 85px;
          line-height: 80px;
        }
       
        .pre-title {
          font-size: 47px;
          line-height: 1.2em;

          @media (max-width: 767.98px) {
            font-size: 37px;
          }
        }
        .title-1 {
          font-size: 61px;

          @media (max-width: 767.98px) {
            font-size: 71px;
          }
        }
      }
    }

    .image-banner {
      width: 100%;
      height: 720px;
      object-fit: cover;

      @media (max-width: 767.98px) {
        width: auto;
        height: 100vh;  
        object-fit: cover;
        top: 0;
      }
    }
  }

  .table-content {
    position: sticky;
    top: 15px;
    width: 100%;
    max-width: 260px;
    padding: 0 15px;
    transition: transform .12s ease-in-out;
    height: 100vh;
    overflow-y: auto;
    scroll-behavior: smooth;

    &::-webkit-scrollbar {
      width: 10px;
      cursor: pointer;
    }
    
    &::-webkit-scrollbar-track {
      background: transparent;
    }
    
    &::-webkit-scrollbar-thumb {
      background-color: transparent;
      outline: 1px solid transparent;
    }

    &:hover {
      transform: scale(1.03);
    }

    button {
      padding: 5px;
      border: none;
    }
  }

  .app_description {
    width: 100%;
    max-width: 720px;
    margin: 15px auto;
    font-family: var(--font-family-base);
    font-size: 21px;
    line-height: 25px;
    color: var(--app-color-white);
    text-align: center;
  }

  .show-more-btn {
    width: 100%;
    text-align: center;
    padding: 10px 0;

    .btn-link {
      color: #fff;
      background: var(--app-color-red);
      border-radius: 0;
      transition: transform .25s ease-in-out;
      opacity: 0.9;
    }
    
  }

  .name {
    color: #fff;
  }

  .based {
    color: #e3e3e3;
  }

  .position {
    color: #fff;
  }

  .period {
    color: var(--app-yellow);
  }

  .item-summary {
    font-size: 21px;
    line-height: 31px;
    color: #fff;
    text-align: left;
    background-color: #00000030;
    padding: 15px 30px;

    p {
      line-height: 27px;
    }
  }

  .card {
    background-color: transparent;
  }

  .real_estate_header {
    img.cover {
      width: 100%;
    }

    img.logo {
      width: 100%;
      max-width: 220px;
    }
  }

  .character_img {
    border-radius: 50%;
    width: 250px;
    height: 250px;
    object-fit: contain;
    object-position: center top;

    @media (max-width: 767.98px) {
      width: 180px;
      height: 180px;
    }
  }

  .character_img_mobile {
    margin: 0 auto;
  }

  .sharing-options__link {
    display: block;
    margin: 0.25rem;
    background: rgb(33, 33, 33);
    height: 2.5em;
    line-height: 2.5em;
    width: 2.5em;
    text-align: center;
    font-size: 80%;
    border-radius: 50%;
    cursor: pointer;
    color: #fff;
    position: relative;
  }

  h2.quote {
    font-family: var(--font-family-base);
    color: var(--app-yellow);
    font-size: 21px;
    font-weight: 300;

    @media (max-width: 767.98px) {
      font-size: 27px;
    }

    a {
      color: #333;
    }
  }

  h3.case_title {
    font-family: var(--font-family-base);
    color: var(--app-color-red);
    font-size: 27px;
    font-weight: 300;
    text-align: center;

    @media (max-width: 767.98px) {
      font-size: 21px;
    }

    a {
      color: var(--app-color-red);
    }
  }
  h3.author {
    font-family: var(--font-family-base);
    color: var(--app-color-red);
    font-size: 21px;
    font-weight: 600;
    text-align: left;

    @media (max-width: 767.98px) {
      font-size: 18px;
    }
  }

  .full-title {
    color: var(--app-color-black);
    font-size: 41px;
    margin-bottom: 15px;

    @media (max-width: 767.98px) {
      font-size: 27px;
    }

    a {
      color: #333;
    }
  }

  h4 {
    font-size: 18px;
    font-weight: 300;
    text-transform: uppercase;
    color: var(--app-color-black);
  }

  .case-hide {
    font-size: 20px;

    p {
      font-size: 20px;
      line-height: 40px;
      margin-bottom: 21px;
    }
  }

  .item-gallery-effect {
    position: relative;
    margin-bottom: 35px;
    opacity: 1;
    transition: opacity .1s ease-in-out;

    &.active-item {
      opacity: 1;
    }

    .property-value {
      position: absolute;
      top: 15px;
      right: 15px;
      height: 80px;
      padding: 10px 0;
      font-size: 27px;
      font-weight: 600;
      color: #fff;
      line-height: 1.2em;
      background: var(--app-color-red);
    }

    .card-image {
      position: relative;

      h3 {
        position: absolute;
        top: 15px;
        left: -15px;
        padding: 0 15px;
        color: var(--app-color);
        background-color: var(--app-color-black);
      }

      img {
        width: 100%;
        max-width: 320px;
      }
    }

    .property-owner {
      font-size: 17px;
      text-align: left;
      line-height: 1.2em;
      border-bottom: solid 1px var(--app-color);

      .image-owner {
        background: var(--app-color-red);
        border-radius: 100%;
      }
    }

    .property-comments {
      font-size: 18px;
      line-height: 1.1em;
      text-align: left;

      li {
        margin-bottom: 15px;
      }
    }

    .property-narrative {
      font-size: 18px;
      text-align: left;
    }
  }
</style>

<script>
  import utils from '@/mixins/utils'
  import kebabCase from 'lodash/kebabCase'
  import find from 'lodash/find'
  import AppFooterEmbed from '@/components/AppFooterEmbed'
  import CustomSharingOptions from '@/components/CustomSharingOptions.vue'
  import FileIcons from '@/components/FileIcons.vue'

  export default {
    name: 'Embed',
    mixins: [utils],
    components: {
      AppFooterEmbed,
      CustomSharingOptions,
      FileIcons
    },
    props: {
      content: {
        type: Object,
        default: null
      }
    },
    computed: {
      case_item() {
        return find(this.content.cases, item => {
          if(item.image_path == this.$route.params.url_case ) {
            console.log(item)
            return item
          }        
        })
      }
    },
    methods: {
      kebabCase
    }
  }

</script>